import { Type } from "@angular/core";
import "reflect-metadata";

export interface FullscreenData{
    isOpen: boolean, 
    componentType?: Type<any>, 
    instance?: any
    data?: any
}

export interface Fullscreenable<T>{
    /**
     * Gibt an ob sich komponente gerade in Fullscreen befindet oder Modal
     */
    isFullscreen: boolean,


    /**
     * Button die in Header angezeigt werden im Fullscreen-Modus
     */
    fullscreenButtons?: FullscreenButton[]

    /**
     * Breadcrubs die bei fullscreen links oben angezeigt werden
     */
    fullscreenBreadCrumbs?: FullscreenBreadcrumb[]

    /**
     * Setzt beim Wechseln in Fullscreen die Daten vom Modal
     * @param {T} reference  Referenz der Klasse des Fullscreens woher Daten kommen
     */
    // setInstanceDataAfterChecked(reference: T): void

    /**
     * Wird aufgerufen wenn man Status der Komponente wechseln will
     * @example  this.feedback.openModalInFullscreen(PdfViewerPage, this)
     */
    toogleFullscreen(): Promise<void>

}

export interface FullscreenButton{

    /**
     * name des Ion Icons 
     */
    ionIcon?: string

    /**
     * svg wenn nicht ion ion verwendet werden soll als button bild
     * @deprecated use ionIcon instead 
     */
    svg?: string

    /**
     * Text der als title angezeigt wirde wenn man mit Maus drüber geht
     */
    title?: string

    /**
     * Function die ausgeführt werden soll wenn man auf den Button drückt
     */
    action: (event: any) => void
}

export interface FullscreenBreadcrumb{

    /**
     * Bezeichnung des Breadcrumbs
     */
    name: string

    /**
     * Action welche beim clicken aufgerufen wird
     */
    action?: () => void
}

const formatMetadataKey = Symbol("isFullscreenProperty");

/**
 * Setzt Metadaten bei Property mit @FullscreenProperty()
 * @returns 
 */
export function FullscreenProperty() {
    return Reflect.metadata(formatMetadataKey, true)
}

/**
 * Gibt zurück ob eigenschaft einer Instance eine Fullscreen-Property ist
 * @param {any} target instace wo property vorhanden ist
 * @param {string} propertyKey Name der Eigenschaft, die überprüft werden soll ob sie eine Fullscreen-Eigenschaft ist
 * @returns undefinded wenn sie es nicht ist
 */
export function isFullscreenableProperty(target: any, propertyKey: string) {
  return Reflect.getMetadata(formatMetadataKey, target, propertyKey);
}